import { useState } from "react";

export type DeleteStep = "initial" | "success";

export const useDeleteStep = () => {
  const [step, setStep] = useState<DeleteStep>("initial");

  return { step, setStep };
};
